// https://github.com/glidejs/glide

import Glide from '@glidejs/glide';
import Base from './base';

class Announcements extends Base {
	start() {
		if (!this.query('.js-slider-item')) {
			return;
		}

		this.createGlider();
		this.createPagination();
	}

	createGlider() {
		this.glide = new Glide(this.refs.slider, {
			// using `slider` same as `carousel` component
			type: 'slider',
			bound: true,
			rewind: false,
			animationDuration: 250,
			startAt: 0,
			perView: 1,
		});

		this.glide.mount();
		this.glide.on('run', () => this.onGlided());
	}

	createPagination() {
		this.buttons = this.queryAll('.js-slider-link');

		this.buttons.forEach((button, index) => {
			button.addEventListener('click', e => this.onButtonClicked(e, index));
		});
	}

	onButtonClicked(e, index) {
		e.preventDefault();

		this.gotoSlide(index);
	}

	onGlided() {
		this.updatePagination();
	}

	gotoSlide(index) {
		// https://glidejs.com/docs/api/
		// ={i} - Go to {i} zero-based slide (eq. '=1', will go to second slide)
		this.glide.go(`=${index}`);
	}

	updatePagination() {
		const { index } = this.glide;
		const activeButton = this.buttons.find(b => b.classList.contains('is-active'));

		if (activeButton) {
			activeButton.classList.remove('is-active');
		}

		this.buttons[index].classList.add('is-active');
	}
}

export default Announcements;
